import axios from "axios";
export default {
  namespaced: true,
  state: {
    data: [],
  },
  getters: {
    data: state => state.data,
  },
  mutations: {
    setData(state, payload) {
      state.data = payload.data;
    },
  },
  actions: {
    async getData({ commit }, value) {
      commit("config/SET_OVERLAY", true, { root: true });
      try {
        const url = value.search
          ? `/api/support-tickets?page=${value.currentPage}&search=${value.search}`
          : `/api/support-tickets?page=${value.currentPage}`;
        const res = await axios.get(url);
        commit("setData", res.data);
        return res.data;
      } catch (error) {

        throw error;
      } finally {
        commit("config/SET_OVERLAY", false, { root: true });
      }
    },
  }
};
